import {
    ChevronRightIcon, CogIcon, HeroCalendarDaysIcon, HeroShieldExclamationIcon,
} from 'components/Icon/Icon'
import {
    ItemDisplayType, NestedDefaultMenuBarProps,
} from './types'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'
import React from 'react'

import {chevronWrapper} from '../styles/Menubar'
import {navigation} from 'navigation'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const StyledChevronWrapper = styled('div', chevronWrapper)

export const DefaultMenuBarChannelSettings = (props: NestedDefaultMenuBarProps<'ChannelSettings'> & {channelId: string}) => {
    const {
        params, type, channelId,
    } = props
    const {t} = useTranslation()

    const showSchedule = params.tab === 'schedule'
    const showPrivacy = params.tab === 'privacy'

    return (
        <>
            {/* eslint-disable-next-line no-extra-parens */}
            {(type === ItemDisplayType.middleItems && (params?.tab)) || type === ItemDisplayType.all || (type === ItemDisplayType.lastItem && !params?.tab) ?
                <>
                    {type !== ItemDisplayType.middleItems && <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>}
                    <Button
                        color='text'
                        iconLeft={CogIcon}
                        onPress={() => navigation.push('ChannelSettings', {channel_id: channelId})}
                        text={t('Channel settings')}
                    />
                </>
                : null}
            {type === ItemDisplayType.lastItem || type === ItemDisplayType.all ?
                <>

                    {
                        showPrivacy ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={HeroShieldExclamationIcon as unknown as Icon}
                                    onPress={() => navigation.push('ChannelSettings', {
                                        channel_id: channelId,
                                        tab: 'privacy',
                                    })}
                                    text={t('Privacy')}
                                />
                            </>
                            : null
                    }
                    {
                        showSchedule ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={HeroCalendarDaysIcon as unknown as Icon}
                                    onPress={() => navigation.push('ChannelSettings', {
                                        channel_id: channelId,
                                        tab: 'schedule',
                                    })}
                                    text={t('Schedule')}
                                />
                            </>
                            : null
                    }
                </>
                : null }
        </>
    )
}

// eslint-disable-next-line react/default-props-match-prop-types
DefaultMenuBarChannelSettings.defaultProps = {type: ItemDisplayType.all}
